import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { operators } from "components/Layout/Campaign/Common/campaignHelpers";
import { Field, FieldProps } from "formik";
import { useMessage } from "hooks/intl";
import { NewFormatConditionType, OperatorId } from "types/campaigns";

interface Props {
  type: NewFormatConditionType;
  fieldName: string;
}

export const ConditionOperator = ({ type, fieldName }: Props) => {
  const { message } = useMessage();
  const arrayOperators = [
    OperatorId.IN,
    OperatorId.NOT_IN,
    OperatorId.ONE_OF,
    OperatorId.NOT_ONE_OF,
  ];

  return (
    <Field name={`${fieldName}.operator`}>
      {({ form }: FieldProps) => (
        <SelectInput
          items={operators[type]?.map((item) => ({
            id: item.id,
            label: message({ id: item.label }),
          }))}
          label={<RequiredFieldLabel text={message({ id: "condition" })} />}
          name={`${fieldName}.operator`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const currentOperator = e.target.value as OperatorId;

            form.setFieldValue(
              `${fieldName}.value`,
              arrayOperators.includes(currentOperator) ? [] : undefined,
            );
          }}
          data-test-id="condition-operator"
        />
      )}
    </Field>
  );
};
